import { useDispatch, useSelector, connect } from "react-redux";
import React, { useEffect } from 'react';
import { Backdrop, CircularProgress, Grid } from "@material-ui/core";
import { RightArrowIcon } from "../Common/SVGBank";
import moment from "moment";
import { landing_router, URL_REPLACE } from "../Common/RegExValidate";

import { getHomeDetails, setTimeLineStatus } from "../../../redux/actions";
import { useHistory } from 'react-router-dom';
import * as Actions from '../../../redux/actions';
import TagManager from 'react-gtm-module';
import { resetFlightPage, updateFlightData } from "../FlightsPage/services/Flights.slice";
import { createTripThunk } from "../FeaturePage/personalizedTrip/personalizedTrip.slice";
import { PersonalizedModalUseStyles } from "../Common/BookingForm/AiPersonalizedTrip/AiPersonalizedTripStyles";
import { HotelFlightSaveModal } from "../FlightsPage/RecapPage/FlightSaveModal";
import { getNearByAirport, saveHotelTimeline } from "../BookingPage/PaymentPage/payment.thunk";
import { GetExpediaBooking } from "./muvMeta.services";

const CongratulationsHotel_ = ({ uuid, booking_bundles, registerMemberAccount, setSwitchProfileContainer }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = PersonalizedModalUseStyles();
    const [home, setHome] = React.useState();
    const cartData = useSelector(state => state.HotelBooking.cart.data);
    const nearByDestination = useSelector(state => state.Flights.nearByDestination);
    const firstName = useSelector(state => state.Member.authModal.firstName) || '';

    const [expediaDetails, setExpediaDetails] = React.useState()

    const hotelInfo = cartData?.items?.[0];
    const isExpedia = !!(hotelInfo?.hotel_provider === "exp");

    const hotelName = hotelInfo?.hotel_name;
    const checkin = moment(hotelInfo?.check_in).format('MMM Do');
    const checkout = moment(hotelInfo?.check_out).format('MMM Do');
    const bookingNumber = cartData?.id;
    var searchParams = new URLSearchParams(document.location.search.substring(1));
    const email = searchParams.get("email")
    const affiliateId = searchParams.get("affiliateId")
    const itineraryId = expediaDetails?.itinerary_id;
    const arrivalCity = expediaDetails?.hotel_data?.city?.name;
    const selectedCurrency = useSelector(state => state.Setting.currency.selected.shortCode);
    const fullCurrency = selectedCurrency ? selectedCurrency.toUpperCase() : "CAD";
    const geo = expediaDetails?.hotel_data?.city?.MuvMetaCity;

    useEffect(() => {
        if (geo) {
            dispatch(getNearByAirport({
                lat: geo.latitude, lng: geo.longitude
            }));
        }
    }, [geo]);



    const goToBooking = () => {
        if (affiliateId && email) {
            const url = `/payment/details?email=${email}&affiliateId=${affiliateId}`;
            window.open(url);
        }
    };


    const goToFlight = () => {
        try {

            let destination = expediaDetails?.hotel_data?.city?.MuvMetaCity;
            let prevDestination;
            const homeAirport = home?.homeAirport;
            let flights = []
            let flightMode = "one_way"

            flights = [
                {
                    "airportFrom": {
                        "city": homeAirport?.airportCity ?? "",
                        "latitude": homeAirport?.airportLatitude ?? "",
                        "city_code": homeAirport?.airportCode ?? "",
                        "type": "main",
                        "iata": homeAirport?.airportCode ?? "",
                        "airport": "All Airports"
                    },
                    "airportTo": {
                        "city": destination?.city + " " + destination?.country ?? "",
                        "latitude": destination?.latitude ?? "",
                        "city_code": destination?.country_code ?? "",
                        "type": "main",
                        "iata": destination?.country_code ?? "",
                        "airport": "All Airports"
                    },
                    "departureDateFormat": hotelInfo?.check_in ? new Date(moment(hotelInfo?.check_in)) : new Date(moment()),
                    "departureDate": hotelInfo?.check_in ? new Date(moment(hotelInfo?.check_in)) : new Date(moment()),
                    "availableSelectDate": new Date().toDateString(),
                    "positionId": "d-0"
                }]





            let dataToBookingFlights = {
                flightMode: flightMode,
                cabinClass: 'economy',
                numberAdult: 1,
                numberChild: '0',
                flights: flights,
                currency: fullCurrency

            }

            // dispatch(updateFlightData(dataToBookingFlights))


            const flightDates = [...flights]?.map((flight) => {
                const formatDate = moment.parseZone(flight?.departureDate)?.format("YYYY-MM-DD")?.toString()?.split("-");
                const dateString = `${formatDate[2]}${formatDate[0] < 10 ? "0" + formatDate[0] : formatDate[0]}${formatDate[1] < 10 ? "0" + formatDate[1] : formatDate[1]}`
                return `${flight?.airportFrom?.iata}-${flight?.airportTo?.iata}-${formatDate?.join('') ?? ""}`
            })


            let flightUrl = `/flight/search?flightMode=${flightMode}&cabinClass=${dataToBookingFlights?.cabinClass || 'economy'}&numberAdult=${dataToBookingFlights?.numberAdult}&numberChild=${dataToBookingFlights?.numberChild || 0}&flights=${flightDates?.toString()}`;

            dispatch(resetFlightPage())
            history.push(flightUrl)



        }

        catch (err) {
            console.log(err)
        }
    }

    const goToDestination = () => {
        const dest = nearByDestination;
        if (dest) {
            const url = "/destination/" + dest?.name.replace(URL_REPLACE, "-") + "/" + 1 + "/" + dest?.destinationId;
            history.push(url.toLowerCase());
        }
    }

    React.useEffect(() => {
        getHomeDetails().then(data => {
            setHome(data)
        })
    }, [uuid])



    React.useEffect(() => {
        if (email && affiliateId && isExpedia) {
            const fetchBooking = async () => {
                const result = await GetExpediaBooking(email, affiliateId)
                setExpediaDetails(result?.result?.[0]);
            }
            fetchBooking()
        }
    }, [email, affiliateId, isExpedia])


    if (!cartData || !cartData.items || cartData.items.length === 0) {
        return <p>No booking information available.</p>;
    }




    return (
        <Grid container style={{ padding: 20 }}>
            <Backdrop className={classes.backdrop} open={false}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {isExpedia ? <Success
                checkin={checkin} checkout={checkout} firstName={firstName} hotelName={hotelName} bookingNumber={expediaDetails?.rooms?.[0]?.confirmation_id?.expedia} goToBooking={goToBooking}
                arrivalCity={arrivalCity} goToDestination={goToDestination}
                itineraryId={itineraryId}
                goToFlight={goToFlight} /> :
                <Success
                    checkin={checkin} checkout={checkout} firstName={firstName} hotelName={hotelName} bookingNumber={bookingNumber} goToBooking={goToBooking}
                />}

        </Grid>
    );
};


const CongratulationsHotel = connect(null, null)(CongratulationsHotel_);
export default CongratulationsHotel;


const Success = ({ goToFlight, goToDestination, arrivalCity, firstName, hotelName, checkin, checkout, bookingNumber, goToBooking, itineraryId }) => {
    return (
        <>
            <Grid item>
                <div>
                    <p style={{ font: '24px/24px Futura Hv BT' }}> Congratulations {firstName},</p>
                </div>

                <div>
                    <p style={{ marginTop: 20, font: '20px/20px Futura Md BT', lineHeight: '30px' }}>
                        Your booking for {hotelName} from {checkin} to {checkout} is complete.
                    </p>

                    {bookingNumber && <p style={{ marginTop: 20, font: '20px/20px Futura LT BT', lineHeight: '30px' }}>
                        Your booking reference number is {bookingNumber}.
                    </p>}

                    {itineraryId && <p style={{ marginTop: 20, font: '20px/20px Futura LT BT', lineHeight: '30px' }}>
                        Your itinerary id is {itineraryId}.
                    </p>}

                    <p style={{ marginTop: 20, font: '20px/20px Futura LT BT', lineHeight: '30px' }}>
                        You will soon receive a confirmation email with all your booking information.
                    </p>
                    <p style={{ marginTop: 20, font: '20px/20px Futura LT BT', lineHeight: '30px' }}>For any information or help with your booking, please call our customer service center at <a href="tel:+1-800-230-0925" type="tel">1-800-230-0925</a>.</p>

                    <p style={{ marginTop: 20, font: '20px/20px Futura MD BT', lineHeight: '30px' }}>You can safely continue planning your trip.</p>
                </div>
            </Grid>

            <Grid item style={{ marginTop: 60, width: '100%' }}>
                <div>
                    <button className='recapButtons' style={{ background: '#DFDFDF' }} onClick={goToBooking}>
                        See Booking Details
                    </button>

                    <div style={{ float: "right", textAlign: "right" }}>
                        <button className='recapButtons' style={{ background: '#19BC9B', color: 'white', font: '14px/14px Futura Hv BT' }} onClick={goToFlight}>
                            <span style={{ paddingRight: 60, font: '14px/14px Futura Hv BT' }}>  Find a Flight  </span>
                            <RightArrowIcon height={14} width={14} />
                        </button>
                        {arrivalCity && <div onClick={goToDestination} style={{ marginTop: 10, font: '14px/14px Futura Hv BT', cursor: "pointer", }}>
                            <p>Skip to  <u> explore things to see & do in {arrivalCity}  </u></p>
                        </div>}
                    </div>
                </div>

            </Grid >
        </>
    )
}